/* global module require */
const lib = require('./tv_base.js');
lib.faq_schema = require('../tv_faq_schema/faq_schema.ts');
lib.faq_section = require('../tv_utils/faq_section.ts');
module.exports = lib;
